module.exports = __webpack_public_path__ + "img/one_on_one.ead0aac5.svg";